import { CandidateSelectors } from '@core/candidate-data';
import type { GdprRequest } from '@core/gdpr-types';
import { createEntityCollectionStore, memoizeSelector } from '@core/ngrx-legacy';

export const candidateScope = (id: number) => `candidate:${id}`;

const idSelector = ({ id }: { id: number }) => id;
const { actions, selectors, reducer, namespace } = createEntityCollectionStore<GdprRequest>()(
  'GdprRequest',
  {
    idSelector,
    references: makeRef => [makeRef('candidateId', 'candidate', CandidateSelectors.byId)],
    customActions: adapter => ({
      fetchCollection: (state, payload: { candidateId: number }) =>
        adapter.markAsPending(state, { scope: candidateScope(payload.candidateId), entities: [] }),

      complete: (state, payload: { requestId: number }) => state,
      completeSuccess: (state, payload: { data: GdprRequest }) => state,
      completeFailed: (state, payload) => state,
    }),
  },
);

const GdprRequestActions = <
  Pick<
    typeof actions,
    | 'fetchCollection'
    | 'fetchCollectionSuccess'
    | 'fetchCollectionFailed'
    | 'complete'
    | 'completeSuccess'
    | 'completeFailed'
  >
>actions;

const GdprRequestSelectors = {
  ...selectors,
  byCandidateId: memoizeSelector((candidateId: number) =>
    selectors.entitiesWithReferences({ scope: candidateScope(candidateId) }),
  ),
};

export {
  GdprRequestActions,
  actions,
  GdprRequestSelectors,
  reducer as GdprRequestReducer,
  namespace as GdprRequestNamespace,
};
